import React from 'react';
export { ID_PENALTY_KEYS, SELFIE_PENALTY_KEYS } from 'models/jobs/jobs';
export var IdDocumentItemTitle;
(function (IdDocumentItemTitle) {
    IdDocumentItemTitle["ValidPhysicalId"] = "Valid Physical ID";
    IdDocumentItemTitle["ValidDigitalId"] = "Valid Digital ID";
    IdDocumentItemTitle["ExpirationDate"] = "Expiration Date";
    IdDocumentItemTitle["ValidSelfie"] = "Valid Selfie";
    IdDocumentItemTitle["IdMatchesSelfie"] = "ID Matches Selfie";
    IdDocumentItemTitle["IdMatchesBarcode"] = "ID Matches Barcode";
    IdDocumentItemTitle["IdMatchesSubmittedName"] = "ID Matches Submitted Name";
    IdDocumentItemTitle["IdMatchesSubmittedDob"] = "ID Matches Submitted DOB";
    IdDocumentItemTitle["BarcodePresence"] = "Barcode Presence";
    IdDocumentItemTitle["SelfieLivenessPerformed"] = "Selfie Liveness Performed";
    IdDocumentItemTitle["IdRestrictions"] = "ID Restrictions";
    IdDocumentItemTitle["StableIdPattern"] = "Stable ID Pattern";
    IdDocumentItemTitle["StableSelfiePattern"] = "Stable Selfie Pattern";
    IdDocumentItemTitle["SelfieMatchesReferenceImage"] = "Selfie Matches Reference Image";
    IdDocumentItemTitle["DocumentVoided"] = "US ID Not Voided";
    IdDocumentItemTitle["ValidDriverLicense"] = "Valid Driver License";
})(IdDocumentItemTitle || (IdDocumentItemTitle = {}));
export const getRejReasonsNamesAndDescriptions = (rejectionReasons, reasonKeys) => {
    if (!rejectionReasons)
        return [];
    return rejectionReasons
        .filter((reason) => reasonKeys.has(reason.key))
        .map((reason) => ({
        name: REASON_KEY_DISPLAY_NAMES[reason.key],
        description: reason.description
    }));
};
const REASON_KEY_DISPLAY_NAMES = {
    'id-card-detection': 'Card Detection',
    'id-paper-print': 'Paper Print',
    'id-distance-paper-print': 'Distance Paper Print',
    'id-distance-faces-mismatch': 'Distance Faces Mismatch',
    'id-image-manipulation': 'Image Manipulation',
    'id-primary-face-detection': 'Primary Face Detection',
    'id-e-screen': 'E-Screen',
    'id-distance-e-screen': 'Distance E-Screen',
    'id-data-extraction': 'Data Extraction',
    'id-primary-face-image-quality': 'Primary Face Image Quality',
    'id-known-fraudulent-name': 'Known Fraudulent Name',
    'id-public-persona': 'Public Persona Match',
    'id-primary-face-photo-injection': 'Primary Face Photo Injection',
    'id-information-missing': 'Information Missing',
    'id-field-manipulation': 'Field Manipulation',
    'id-primary-face-age-mismatch': 'Primary Face to Age Mismatch',
    'id-unsupported': 'ID Unsupported',
    'back-id-e-screen': 'Back of ID E-Screen',
    'selfie-e-screen': 'E-Screen',
    'selfie-distance-e-screen': 'Distance E-Screen',
    'selfie-id-age-mismatch': 'Selfie to ID Age Mismatch',
    'selfie-face-missing': 'Face Missing',
    'selfie-image-quality': 'Image Quality',
    'selfie-liveness-rejection': 'Liveness Rejection',
    'selfie-public-persona': 'Public Persona Match',
    'selfie-distance-faces-mismatch': 'Selfie Distance Faces Mismatch',
    'selfie-standard-liveness-skipped': 'Standard Liveness Skipped',
    'selfie-enhanced-liveness-skipped': 'Enhanced Liveness Skipped',
    'selfie-enhanced-liveness-failed': 'Enhanced Liveness Failed',
    'id-barcode-mismatch': 'Barcode Mismatch',
    'id-name-mismatch': 'Name Mismatch'
};
export const tableStyleBase = {
    width: '100%',
    overflow: 'hidden'
};
const thStyleBase = {
    padding: '10px 16px',
    fontSize: '1.6rem',
    textTransform: 'uppercase',
    color: '#9A9BA0',
    fontWeight: 700,
    backgroundColor: '#FBFBFC',
    borderBottom: '1px solid #EFEFF1',
    textAlign: 'left'
};
const tdFieldStyleBase = {
    padding: '10px 16px',
    fontSize: '1.6rem',
    fontWeight: 600,
    color: '#1D1D1D',
    borderBottom: '1px solid #F1F1F3'
};
const tdValueStyleBase = {
    padding: '10px 16px',
    fontSize: '1.6rem',
    borderBottom: '1px solid #F1F1F3'
};
export const FieldTd = ({ children }) => (React.createElement("td", { style: tdFieldStyleBase }, children));
export const ValueTd = ({ children }) => React.createElement("td", { style: tdValueStyleBase }, children ?? '-');
export const joinNonEmpty = (parts) => {
    const filtered = parts.filter(Boolean);
    return filtered.length > 0 ? filtered.join(' ') : null;
};
export const tableStyleErrorBase = {
    borderCollapse: 'separate',
    borderSpacing: 0,
    border: '1px solid #ECC9CF',
    borderRadius: '8px'
};
const thStyleErrorBase = {
    backgroundColor: '#F7EEEF',
    color: '#A57078'
};
export const ErrorHeaderTh = ({ width, children }) => (React.createElement("th", { style: { ...thStyleBase, ...thStyleErrorBase, width } }, children));
const thStyleNonErrorBase = {
    color: '#9A9BA0',
    backgroundColor: '#FBFBFC'
};
export const HeaderTh = ({ width, children }) => (React.createElement("th", { style: { ...thStyleBase, ...thStyleNonErrorBase, width } }, children));
